import React from "react";
import "./style.scss";
import RedCross from "../../Assets/red-cross.svg";
import DevStorageAPI from "../../api/DevStorage";
import ConsoleLocalStorage from "../../storage/storage";
import plus from "../../Assets/plus.svg";
import { CustomToast } from "../custom-toast/CustomToast";
import { sliceString, sanitiseUploadFileName } from "../helpers/funcHelper";

/**
 * Strip storage host so KYC register payload stays WAF-safe (no https:// in ARGS:doc.url).
 * @param {string} sasUrlWithoutToken
 * @param {string} [fileName]
 * @returns {string}
 */
export function toRelativeBlobPath(sasUrlWithoutToken, fileName) {
  if (sasUrlWithoutToken && typeof sasUrlWithoutToken === "string") {
    const trimmed = sasUrlWithoutToken.trim().split("?")[0];
    if (/^https?:\/\//i.test(trimmed)) {
      try {
        const { pathname } = new URL(trimmed);
        const relative = pathname.replace(/^\/+/, "");
        if (relative) return relative;
      } catch (e) {
        /* fall through */
      }
    } else if (trimmed) {
      return trimmed.replace(/^\/+/, "");
    }
  }
  if (fileName) return `documents/${fileName}`;
  return "";
}

class FilePicker extends React.Component {
  /*

        Status: 
            0: Select File
            1: Uploading
            2: Uploaded

            
    */

  constructor(props) {
    super(props);
    this.state = {
      status: 0,
      progress: 0,
      name: "",
      errorMsg: "",
      sasFileName: "",
      sasToken: "",
      sasUrl: "",
      sasUrlWithoutToken: "",
    };
    this.selectedFileData = undefined;
  }

  generateSAS() {
    var validExtensions = ["pdf", "png", "jpg", "docx","doc","jpeg"];
    var api = new DevStorageAPI();
    api
      .generateSASForKYCDoc({
        adminId: ConsoleLocalStorage.getUser().id,
        fileName: this.state.name,
      })
      .then((response) => {
        this.setState({
          sasFileName: response.data.data.fileName,
          sasToken: response.data.data.token,
          sasUrl: response.data.data.url,
          sasUrlWithoutToken: response.data.data.url.replace(
            "?" + response.data.data.token,
            ""
          ),
        });

        if (
          validExtensions.includes(response.data.data.fileName.split(".").pop())
        )
          this.uploadFile();
        else this.showError("Invalid File type.");
      })
      .catch((error) => {
        CustomToast(error.response.data.message);
        this.showError("Unable to upload please try uploading again");
      });
  }

  uploadFile() {
    var api = new DevStorageAPI();

    api
      .uploadFile(this.state.sasUrl, this.selectedFileData, (progress) => {
        this.setState({ progress: progress });
      })
      .then((response) => {
        this.setState({ status: 2 });

        // WAF CRS 931130 blocks absolute https:// in upload-kyc body — send relative path only
        const relativePath = toRelativeBlobPath(
          this.state.sasUrlWithoutToken,
          this.state.sasFileName
        );

        this.props.onComplete({
          fileName: this.state.sasFileName,
          url: relativePath,
        });
      })
      .catch((error) => {
        this.props.onComplete({ fileName: "", url: "" });

        this.showError("Unable to upload please try uploading again");
      });
  }

  showError(msg) {
    this.resetFile();
    this.setState({ errorMsg: msg });
  }

  selectFile() {
    var input = document.createElement("input");
    input.type = "file";
    input.accept=this.props.fileTypeCheck;

    input.onchange = (e) => {
      var file = e.target.files[0];
      var fileExtension = "";
      
      if(file.name.lastIndexOf(".") > 0){

        fileExtension = file.name.substring(file.name.lastIndexOf("."), file.name.length);
      }
      if(!this.props.fileTypeCheck.split(",").includes(fileExtension)){
        this.showError("Invalid File type");
        return;
      }
      this.selectedFileData = file;
      this.resetFile();

      this.setState({
        status: 1,

        name: sanitiseUploadFileName(file.name),
      });

      //this.uploadFile();
      this.generateSAS();
      // this.startTimer();
    };

    input.click();
  }

  resetFile() {
    this.setState({
      status: 0,
      progress: 0,
      name: "",
      errorMsg: "",
      sasFileName: "",
      sasToken: "",
      sasUrl: "",
      sasUrlWithoutToken: "",
    });
    this.props.onComplete({ fileName: "", url: "" });
  }

  render() {
    const comp = () => {
      switch (this.state.status) {
        case 1:
          return (
            <div className="file-uploading-container">
              Uploading {this.state.progress}%
              <div className="progress-bar">
                <div
                  className="progress-filled"
                  style={{ width: `${this.state.progress}%` }}
                ></div>
              </div>
            </div>
          );
        case 2:
          return (
            <div className="file-uploaded-container">
              <div className="container"></div>
              <div className="container">{sliceString(0,10,this.state.name,true)}</div>
              <div className="container p-0 text-end">
                <img
                  alt=""
                  onClick={(e) => this.resetFile()}
                  className="red-cross"
                  src={RedCross}
                />
              </div>
            </div>
          );

        default:
          return (
            <div
              className="file-upload-container"
              onClick={(e) => this.selectFile()}
            >
              {this.props.showplus ? (
                <img
                  src={plus}
                  alt="logo"
                  className="mr-1"
                  style={{
                    width: "0.75rem",
                    height: "0.75rem",
                    marginLeft: "0.25rem",
                  }}
                />
              ) : null}
              {this.props.text}
            </div>
          );
      }
    };

    return (
      <React.Fragment>
        {comp()}
        <span className="file-upload-error red">{this.state.errorMsg}</span>
      </React.Fragment>
    );
  }
}

export default FilePicker;
